import { Input, ConfigProvider } from "antd";

const CodeInput = ({ value, length = 6, onChange, onInput }) => {
  const sharedProps = {
    onChange,
    onInput,
  };
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimaryActive: "#310048",
          colorPrimaryHover: "#310048",
        },
        components: {
          Input: {
            activeShadow: "transaprent",
            activeBorderColor: "#310048",
            inputFontSize: 28,
          },
        },
      }}
    >
      <Input.OTP
        // formatter={(str) => str.toUpperCase()}
        length={length}
        value={value}
        {...sharedProps}
      />
    </ConfigProvider>
  );
};
export default CodeInput;
